import { Box, FormControl } from '@mui/material'
import { ReactElement, useEffect, useState } from 'react'
import { getTemplateSubTypes } from '../../../services/entityServices'
import { useTranslation } from 'react-i18next'
import SearchInAPIAndMultiSelectInput from '../../Common/SearchInAPIAndMultiSelectInput'
import { IListItemValue } from '../../../interfaces/Interfaces'

interface ITypeColumnFilter {
    id: string
    label: string
    value: string[]
    onChange: (id: string, value: string[]) => void
    templateId: string
    orgId: string
}
export const TypeColumnFilter = (props: ITypeColumnFilter): ReactElement => {
    const { id, label, value, onChange, templateId, orgId } = props
    const { t } = useTranslation()

    const [selectedValues, setSelectedValues] = useState<IListItemValue[]>([])

    const [recordsList, setRecordsList] = useState<IListItemValue[]>([])

    const [filteredRecordsList, setFilteredRecordsList] = useState<
        IListItemValue[]
    >([])

    const [searchText, setSearchText] = useState<string>('')

    const [isFetching, setIsFetching] = useState(false)

    useEffect(() => {
        if (orgId) {
            setIsFetching(true)
            const getTypes = async () => {
                try {
                    const typesResponse = await getTemplateSubTypes({
                        orgId,
                        templateId,
                    })
                    const recordMap = new Map(
                        typesResponse.map((item) => [item.id, item]),
                    )
                    const updatedValues = value
                        .map((id) => recordMap.get(id))
                        .filter((item): item is IListItemValue => Boolean(item))
                    setSelectedValues(updatedValues)
                    setRecordsList(typesResponse)
                    setFilteredRecordsList(typesResponse)
                } finally {
                    setIsFetching(false)
                }
            }
            getTypes()
        }
    }, [templateId, orgId])

    useEffect(() => {
        if (value?.length) {
            const recordMap = new Map(
                recordsList.map((item) => [item.id, item]),
            )
            const updatedValues = value
                .map((id) => recordMap.get(id))
                .filter((item): item is IListItemValue => Boolean(item))
            setSelectedValues(updatedValues)
        } else {
            setSelectedValues([])
        }
    }, [value, recordsList])

    useEffect(() => {
        // filtering based on search (no seaerch support from API)
        const searechedList = recordsList.filter((i) =>
            i.name.toLowerCase().includes(searchText.toLowerCase()),
        )
        setFilteredRecordsList(searechedList)
    }, [searchText, recordsList])

    const onSelectRecords = (id: string, items: any) => {
        onChangeRecord(id, items)
    }
    const onSearch = (id: string, text: string) => {
        setSearchText(text)
    }

    const onChangeRecord = (id: string, selectedList: []) => {
        const selectedIDs = selectedList.map((i: IListItemValue) => i.id)
        setSelectedValues(selectedList)
        onChange(id, selectedIDs)
    }

    return (
        <Box>
            <Box>
                <FormControl fullWidth size="small">
                    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                        <Box
                            sx={{
                                width: '100%',
                                maxWidth: `100%`,
                            }}
                        >
                            <SearchInAPIAndMultiSelectInput
                                id={id}
                                label={label}
                                placeholder={t('selectLabel', { label })}
                                value={selectedValues}
                                onSelect={onSelectRecords}
                                list={filteredRecordsList || []}
                                hasAddNew={false}
                                onSearch={onSearch}
                                isFetching={isFetching}
                                autoFocusOnMount={true}
                                stopKeyboardPropagation={true}
                            />
                        </Box>
                    </Box>
                </FormControl>
            </Box>
        </Box>
    )
}
